import { render, staticRenderFns } from "./ViewClinic.vue?vue&type=template&id=629aeef1"
import script from "./ViewClinic.vue?vue&type=script&lang=js"
export * from "./ViewClinic.vue?vue&type=script&lang=js"
import style0 from "./ViewClinic.vue?vue&type=style&index=0&id=629aeef1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports